// 貼り付けテキストが「単一の http(s) URL」かを判定する共有ユーティリティ。
//
// キャンバスへの URL 配置（use-paste-handler.ts）と、本文編集中の範囲選択リンク化
// （use-object-text-editor.ts）が同じ判定を参照するため、経路ごとの振り分けがずれない。

/**
 * 貼り付けテキストが「単一の http(s) URL」か。キャンバスへの URL 配置と、
 * 本文編集中の選択リンク化で同じ判定を使う。
 * なお、この判定は貼り付けの振り分け用であり、リンクとして採用してよいかの最終判定は
 * domain の isHttpUrl が行う（両者が食い違う入力は、リンク化を見送って従来経路へ落とす）。
 */
export function isLikelyPasteUrl(text: string): boolean {
  const trimmed = text.trim();
  if (trimmed.length > 2048) return false;
  return /^https?:\/\/[^\s]+$/i.test(trimmed);
}
